export default __webpack_public_path__ + "static/media/plate-heat-exchanger.c946f274.jpg";